const API_HOST = process.env.REACT_APP_API_HOST;
console.log('API_HOST ==>', API_HOST);

export default Object.freeze({
	host: API_HOST,
	baseURL: `${API_HOST}/api/`,
});
